export default __webpack_public_path__ + "static/media/arrow-down.c86f5e8f.svg";